import styled from 'styled-components';

export const Container = styled.img`
  width: 2.25rem;
  height: 2.25rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  margin-right: 1rem;
`;
